import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface ChromaticAberrationEffectProperties extends EffectProperties {
  offset: number;
}

// Create a reusable ChromaticAberration component that can be used in both preview and world
const ChromaticAberrationComponent = forwardRef<any, { properties: ChromaticAberrationEffectProperties; isPreview?: boolean }>((props, ref) => {
  
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }

  const { offset } = properties;

  return (
    <PostProcessing.ChromaticAberration
      ref={ref}
      offset={new THREE.Vector2(offset, offset)}
    />
  );
});

export const ChromaticAberrationEffectItem: Effect<ChromaticAberrationEffectProperties> = {
  id: '',
  name: 'Chromatic Aberration',
  type: 'effect',
  subtype: 'ChromaticAberration',
  icon: 'Effect',
  properties: {
    offset: 0.005,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.offset',
      type: 'number',
      label: 'Offset',
      default: 0.005,
      min: 0,
      max: 0.05,
      step: 0.001,
      panel: 'effect',
    }
  ],
  render: (properties: ChromaticAberrationEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <ChromaticAberrationComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};